import { isActiveChat } from './activeChat';

const pendingBlinkChatIds = new Set();
const listeners = new Set();

let favoritesChatId = null;
let currentUserId = null;
let currentUserConnectId = null;

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const configureChatBlinkContext = ({ favoritesId, userId, connectId } = {}) => {
  if (favoritesId !== undefined) {
    favoritesChatId = favoritesId != null ? String(favoritesId) : null;
  }
  if (userId !== undefined) {
    currentUserId = userId != null ? String(userId) : null;
  }
  if (connectId !== undefined) {
    currentUserConnectId = connectId ?? null;
  }
};

export const getPendingBlinkChatIds = () => [...pendingBlinkChatIds];

export const subscribeChatBlink = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const shouldBlinkIncomingMessage = (messageData) => {
  const chatId = messageData?.chat_id;
  if (!chatId || isActiveChat(chatId)) {
    return false;
  }
  if (favoritesChatId && String(chatId) === favoritesChatId) {
    return false;
  }

  const senderId = messageData?.sender_id;
  const senderConnectId = messageData?.sender_connect_id;

  if (currentUserId && senderId && String(senderId) === currentUserId) {
    return false;
  }
  if (currentUserConnectId && senderConnectId && senderConnectId === currentUserConnectId) {
    return false;
  }

  return true;
};

/** Queue blink for chats page (e.g. before workspace mounts). */
export const recordIncomingChatMessage = (messageData) => {
  if (!shouldBlinkIncomingMessage(messageData)) {
    return false;
  }

  pendingBlinkChatIds.add(String(messageData.chat_id));
  emit();
  return true;
};

export const clearChatBlink = (chatId) => {
  const id = String(chatId);
  if (pendingBlinkChatIds.has(id)) {
    pendingBlinkChatIds.delete(id);
    emit();
  }
};

export const markBlinkHandled = (chatId) => {
  pendingBlinkChatIds.delete(String(chatId));
};

export const resetChatBlinkStore = () => {
  pendingBlinkChatIds.clear();
  favoritesChatId = null;
  currentUserId = null;
  currentUserConnectId = null;
  emit();
};
